/**
 * [INPUT]: 依赖 @elseyou/api-client 的 Authorization token store 与后台浏览器 localStorage
 * [OUTPUT]: 对外提供管理员 token 读取、保存、按版本清理、过期判断和跨 Tab 认证事件
 * [POS]: admin-web 的认证基础设施；请求适配器与 AuthContext 共享同一份 Bearer 会话，不接触 Cookie
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { BearerTokenStore, type AuthTokens } from '@elseyou/api-client';

export const ADMIN_AUTH_EVENT = 'elseyou:admin-auth-changed';

export const adminAuthTokens = new BearerTokenStore(
  window.localStorage,
  'elseyou.admin.auth-tokens.v1',
  'elseyou.admin.auth-refresh-lock.v1',
);

export function getAdminAuthTokens(): AuthTokens | null {
  return adminAuthTokens.get();
}

export function saveAdminAuthTokens(tokens: AuthTokens): void {
  adminAuthTokens.set(tokens);
  window.dispatchEvent(new CustomEvent(ADMIN_AUTH_EVENT));
}

export function clearAdminAuthTokens(expectedRefreshToken?: string): boolean {
  const cleared = adminAuthTokens.clear(expectedRefreshToken);
  if (cleared) window.dispatchEvent(new CustomEvent(ADMIN_AUTH_EVENT));
  return cleared;
}
